import { api, queryString } from '@sentinel/web-core';
import type { QualificationCreate, RegistryList, RegistryPerson } from '@sentinel/shared';

/** Personnel registry of the organization and the qualifications of its people (phase H). */
export const personnelEndpoints = {
  registry: (params: { q?: string | undefined; page: number; pageSize: number }) =>
    api<RegistryList>(`/persons${queryString(params)}`),
  addQualification: (personId: string, body: QualificationCreate) =>
    api<RegistryPerson>(`/persons/${personId}/qualifications`, { method: 'POST', body }),
  removeQualification: (personId: string, qualificationId: string) =>
    api<RegistryPerson>(`/persons/${personId}/qualifications/${qualificationId}`, {
      method: 'DELETE',
    }),
};
